/**
 * Sets a value on the class' prototype
 * @param value The value to set
 * @param configurable Whether the value should be configurable
 * @param enumerable Whether the value should be enumerable
 * @return {(target: any, prop: string) => void}
 */
export function Proto(value, configurable, enumerable) {
    if (configurable === void 0) { configurable = true; }
    if (enumerable === void 0) { enumerable = true; }
    return function (target, propertyKey) {
        Object.defineProperty(target.constructor.prototype, propertyKey, {
            configurable: configurable,
            enumerable: enumerable,
            value: value
        });
    };
}
//# sourceMappingURL=ProtoDecorator.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typescript-proto-decorator/dist/esm5/ProtoDecorator.js
// module id = 33
// module chunks = 0 1